"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTreeNodeReaggregationStatus = exports.ProductTreeNodeReaggregationStatusProvider = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@apollo/client/react");
const client_utils_1 = require("../../client/client.utils");
const product_tree_node_1 = require("../../client/product-tree-node");
const hooks_1 = require("../../hooks");
const store_1 = require("../../../store");
const TERMINAL_NODE_POLL_INTERVAL = 1000;
const PARENT_NODE_POLL_INTERVAL = 2000;
const ProductTreeNodeReaggregationStatusContext = (0, react_1.createContext)({
    updateAggregationStatus: () => { },
    isCheckingReaggregationStatus: false,
    isReaggregationInProgress: false,
    isReaggregationReady: false,
});
const ProductTreeNodeReaggregationStatusProvider = ({ children }) => {
    const catalog = (0, store_1.useSelectedCatalogId)();
    const selectedTreeNode = (0, hooks_1.useSelectedTreeNode)();
    const { id: selectedTreeNodeId, isTerminalNode } = selectedTreeNode !== null && selectedTreeNode !== void 0 ? selectedTreeNode : {};
    const [getAggregationStatusQuery, response] = (0, react_2.useLazyQuery)(product_tree_node_1.GET_PRODUCT_TREE_NODE_AGGREGATION_STATUS, { fetchPolicy: 'no-cache' });
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const currentCallback = (0, react_1.useRef)(null);
    const isPolling = (0, react_1.useRef)(false);
    const { data, startPolling, stopPolling, } = response;
    const isReaggregationInProgress = (0, react_1.useMemo)(() => { var _a, _b; return !!((_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.productAggregatedLabelsNew) === null || _b === void 0 ? void 0 : _b.pendingCounts); }, [data]);
    const isReaggregationReady = !isLoading && !isReaggregationInProgress;
    const handleStartPolling = (0, react_1.useCallback)(() => {
        if (!isPolling.current) {
            isPolling.current = true;
            startPolling(isTerminalNode ? TERMINAL_NODE_POLL_INTERVAL : PARENT_NODE_POLL_INTERVAL);
        }
    }, [isTerminalNode, startPolling]);
    const handleStopPolling = (0, react_1.useCallback)(() => {
        if (isPolling.current) {
            isPolling.current = false;
            stopPolling();
        }
    }, [stopPolling]);
    const executeCallback = (0, react_1.useCallback)(() => {
        var _a;
        (_a = currentCallback.current) === null || _a === void 0 ? void 0 : _a.call(currentCallback);
        currentCallback.current = null;
    }, []);
    const updateAggregationStatus = (0, react_1.useCallback)((callback) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!catalog || !selectedTreeNodeId) {
            return;
        }
        handleStopPolling();
        currentCallback.current = callback || null;
        setIsLoading(true);
        try {
            const getAggregationStatusResponse = yield getAggregationStatusQuery({
                variables: {
                    catalog,
                    productTreeNodeId: selectedTreeNodeId,
                },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(getAggregationStatusResponse);
            const { pendingCounts } = (_c = (_b = (_a = getAggregationStatusResponse.data) === null || _a === void 0 ? void 0 : _a.productTreeNode) === null || _b === void 0 ? void 0 : _b.productAggregatedLabelsNew) !== null && _c !== void 0 ? _c : {};
            if (pendingCounts) {
                handleStartPolling();
            }
            else {
                executeCallback();
            }
        }
        catch (_e) {
            /* empty */
        }
        finally {
            setIsLoading(false);
        }
    }), [catalog, getAggregationStatusQuery, handleStartPolling, handleStopPolling, selectedTreeNodeId, executeCallback]);
    (0, react_1.useEffect)(() => () => {
        handleStopPolling();
        currentCallback.current = null;
    }, [handleStopPolling]);
    (0, react_1.useEffect)(() => {
        if (isReaggregationReady) {
            handleStopPolling();
            executeCallback();
        }
    }, [handleStopPolling, isReaggregationReady, executeCallback]);
    return react_1.default.createElement(ProductTreeNodeReaggregationStatusContext.Provider, { value: {
            updateAggregationStatus,
            isCheckingReaggregationStatus: isLoading,
            isReaggregationReady,
            isReaggregationInProgress,
        } }, children);
};
exports.ProductTreeNodeReaggregationStatusProvider = ProductTreeNodeReaggregationStatusProvider;
const useProductTreeNodeReaggregationStatus = () => (0, react_1.useContext)(ProductTreeNodeReaggregationStatusContext);
exports.useProductTreeNodeReaggregationStatus = useProductTreeNodeReaggregationStatus;
exports.default = exports.ProductTreeNodeReaggregationStatusProvider;
